import { OptionType } from '@flowwai-frontend/shared/common-components'

export const SUPPORTED_MIME_TYPES = [
   'audio/*',
   'image/*',
   'application/*',
   'video/*'
]

//NOTE: while adding new mime type check if preview is supported, else add in UNSUPPORTED_FILE_PREVIEW_MIME_TYPES below
export const SUPPORTED_FILE_UPLOADER_FORMATS: OptionType[] = [
   { label: 'All files accepted', value: '*' },
   { label: 'image/jpeg', value: 'image/jpeg' },
   { label: 'image/png', value: 'image/png' },
   { label: 'image/gif', value: 'image/gif' },
   { label: 'image/bmp', value: 'image/bmp' },
   { label: 'image/svg', value: 'image/svg+xml' },
   { label: 'image/heif', value: 'image/heif' },
   { label: 'audio/mp3', value: 'audio/mpeg' },
   { label: 'audio/wav', value: 'audio/wav' },
   { label: 'audio/aac', value: 'audio/aac' },
   { label: 'video/mp4', value: 'video/mp4' },
   { label: 'video/3gp', value: 'video/3gpp' },
   { label: 'video/webm', value: 'video/webm' },
   { label: 'application/pdf', value: 'application/pdf' },
   { label: 'application/doc', value: 'application/msword' },
   {
      label: 'application/docx',
      value:
         'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
   },
   { label: 'application/ppt', value: 'application/vnd.ms-powerpoint' },
   {
      label: 'application/pptx',
      value:
         'application/vnd.openxmlformats-officedocument.presentationml.presentation'
   },
   { label: 'application/xls', value: 'application/vnd.ms-excel' },
   {
      label: 'application/xlsx',
      value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
   },
   {
      label: 'image/dwg',
      value: 'image/vnd.dwg'
   },
   { label: 'application/json', value: 'application/json' },
   { label: 'application/zip', value: 'application/zip' },
   { label: 'application/rar', value: 'application/vnd.rar' },
   { label: 'text/xml', value: 'text/xml' },
   { label: 'text/csv', value: 'text/csv' },
   { label: 'text/plain', value: 'text/plain' },
   { label: 'application/dwg', value: 'application/dwg' },
   { label: 'application/x-dwg', value: 'application/x-dwg' },
   { label: 'application/acad', value: 'application/acad' },
   { label: 'application/x-acad', value: 'application/x-acad' },
   { label: 'application/x-autocad', value: 'application/x-autocad' },
   { label: 'application/autocad_dwg', value: 'application/autocad_dwg' },
   { label: 'image/x-dwg', value: 'image/x-dwg' }
]

export const UNSUPPORTED_FILE_PREVIEW_MIME_TYPES = [
   'image/tiff',
   'image/heif',
   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
   'application/msword',
   'application/vnd.ms-powerpoint',
   'application/vnd.openxmlformats-officedocument.presentationml.presentation',
   'application/vnd.ms-excel',
   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
   'text/csv',
   'application/zip',
   'image/vnd.dwg',
   'application/vnd.rar',
   'application/dwg',
   'application/x-dwg',
   'application/acad',
   'application/x-acad',
   'application/x-autocad',
   'application/autocad_dwg',
   'image/x-dwg'
]

export const DWG_MIME_TYPE = 'dwg'

export const KB_TO_BYTES_MULTIPLIER = 1024

export const MB_TO_BYTES_MULTIPLIER = 1024 * KB_TO_BYTES_MULTIPLIER
export const UPLOADED_FILE_ACTIONS_TOOLTIP_ID =
   'uploaded-file-actions-tooltip-id'
